var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-decoration" }, [
    _c("div", { staticClass: "layout" }, [
      _c(
        "div",
        { staticClass: "layout-left" },
        [
          _c("LeftSideMenu", {
            on: { select: _vm.handleSelect },
            model: {
              value: _vm.selectedKey,
              callback: function ($$v) {
                _vm.selectedKey = $$v
              },
              expression: "selectedKey",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-right" },
        [
          _c("RightSideMenu", {
            attrs: { "selected-left-key": _vm.selectedKey },
            on: { select: _vm.handleRightSelect },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "layout-content" }, [
        _c("div", { staticClass: "content-header" }, [
          _c("h3", [_vm._v(_vm._s(_vm.currentComponentTitle))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-body" },
          [
            _vm.currentComponent
              ? _c(_vm.currentComponent, {
                  key: _vm.selectedRightKey,
                  tag: "component",
                  attrs: {
                    title: _vm.currentComponentTitle,
                    "page-key": _vm.selectedKey,
                    "module-key": _vm.selectedRightKey,
                    "xcx-type": _vm.xcxType,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }